import React, { Component } from 'react';
import { formatarReal } from '../../util/numberUtil';
import Moment from 'react-moment';

export default class ReciboCupomBagagem extends Component {

    linha() {
        return <hr style={{ borderStyle: 'dashed', borderWidth: 3 }} />
    }

    exibirLimiteCupom() {
        return <div className='printer-element'>--</div>
    }

    exibirFormasPagamento() {
      if(!this.props.bagagem)
        return ''
      return this.props.bagagem.formasPagamento.map((it, index) => <React.Fragment key={`formas-pagamento-${index}`}>
          <tr>
              <td colSpan="3">Forma de pagamento:</td>
          </tr>
          <tr>
              <td colSpan="3">{it.tipo}: {formatarReal(it.valor.toString())}</td>
          </tr>
          <tr>
             <td colSpan="3">Parcelas: {it.quantidadeParcelas ? it.quantidadeParcelas: '1'} X</td>
          </tr>
      </React.Fragment>)

      }


    exibirCupom(via, passageiro) {
        const { bagagem, empresaSelecionada } = this.props;
        return (
            <div>
                {this.exibirLimiteCupom()}
                <table className="printer-ticket">
                    <thead>
                        {this.exibirCabecalho(via, passageiro, empresaSelecionada?.nome, empresaSelecionada?.cnpj)}
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan="3"><strong>Nº Reserva:</strong> {bagagem.reservaId}</td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>Identificador:</strong> {bagagem.codigoRastreio}</td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>Passageiro:</strong> {bagagem.nomePassageiro}</td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>Vendedor:</strong> {bagagem.nomeVendedor}</td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>Tipo de cálculo:</strong> {bagagem.descTipoCalculoBagagem}</td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>Data emissão:</strong>
                            <Moment format="DD/MM/YYYY">{bagagem.dataHoraRegistro}</Moment></td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>Valor:</strong> {bagagem.valor?.toLocaleString('pt-BR', {
                                                                                                  style: 'currency',
                                                                                                  currency: 'BRL',
                                                                                                }) || 'R$ 0,00'}</td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>Peso:</strong> {bagagem.peso} kg</td>
                        </tr>
                        {bagagem.valorTipoCalculoBagagem === 'VALOR_POR_METRO_CUBICO' && bagagem.volumeTotalMetroCubico != null && (
                            <tr>
                                <td colSpan="3">
                                    <strong>Cubagem total:</strong> {Number(bagagem.volumeTotalMetroCubico).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} m³
                                </td>
                            </tr>
                        )}
                        {bagagem.itensMetroCubico && bagagem.itensMetroCubico.length > 0 && (
                            <>
                                <tr><td colSpan="3"><strong>Volumes:</strong></td></tr>
                                {bagagem.itensMetroCubico.map(it => (
                                    <tr key={it.id || it.sequencia}>
                                        <td colSpan="3">
                                            {it.sequencia}/{bagagem.reservaId} — {it.descricao || 'Caixa'} ({Number(it.comprimento).toLocaleString('pt-BR')}×{Number(it.largura).toLocaleString('pt-BR')}×{Number(it.altura).toLocaleString('pt-BR')} cm) = {Number(it.volumeUnitario).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} m³
                                        </td>
                                    </tr>
                                ))}
                            </>
                        )}
                         {this.exibirFormasPagamento()}
                        <tr>
                            <td colSpan="3">&nbsp;&nbsp;</td>
                        </tr>

                        <tr style={{ textAlign: 'center' }}>
                            <td className="title" colSpan="3">
                                OS número: {bagagem.reservaId}
                            </td>
                        </tr>

                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan="3" align='center'>
                                <span className="text-break" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    Observação: {!bagagem.observacao ? 'Inclusão de bagagem extra' : bagagem.observacao}
                                </span>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                {this.exibirLimiteCupom()}
            </div>
        )
    }

    exibirCabecalho(label, pessoa, nomeEmpresa, cnpj) {
        const { bagagem } = this.props;
        return (
            <>
                <tr>
                    <th className="title" colSpan="3">
                        {nomeEmpresa}
                        <br />
                        <strong>CNPJ:</strong> {cnpj}
                    </th>
                </tr>
                <tr>
                    <th colSpan="3">{bagagem.dataCriacao}</th>
                </tr>
                <tr>
                    <td colSpan="3">&nbsp;&nbsp;&nbsp;&nbsp;</td>
                </tr>
                {!bagagem.ativa?
                    <tr style={{ textAlign: 'center' }}>
                        <td className='title' colSpan="3">
                            ***** CANCELADA ******
                        </td>
                    </tr>
                 :''}
                <tr style={{ textAlign: 'center' }}>
                    <td colSpan="3">
                        {pessoa?.nome || bagagem.nomePassageiro}
                        <br />
                        {pessoa?.cpfCnpj}
                    </td>
                </tr>
                <tr style={{ textAlign: 'center' }}>
                    <td className='title' colSpan="3">
                        Via {label}
                    </td>
                </tr>
            </>
        )
    }

    exibirEtiquetaVolume(item, bagagem, nomeEmpresa) {
        return (
            <div key={`etiqueta-vol-${item.sequencia}`}>
                <div className="pagebreak"></div>
                {this.exibirLimiteCupom()}
                <table className="printer-ticket">
                    <thead>
                        <tr>
                            <th className="title" colSpan="3">{nomeEmpresa}</th>
                        </tr>
                        <tr>
                            <td colSpan="3">&nbsp;</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style={{ textAlign: 'center' }}>
                            <td className="title" colSpan="3" style={{ fontSize: '1.6em', letterSpacing: 2 }}>
                                {item.sequencia}/{bagagem.reservaId}
                            </td>
                        </tr>
                        <tr style={{ textAlign: 'center' }}>
                            <td colSpan="3"><strong>Etiqueta de Volume</strong></td>
                        </tr>
                        <tr><td colSpan="3">&nbsp;</td></tr>
                        <tr>
                            <td colSpan="3"><strong>Passageiro:</strong> {bagagem.nomePassageiro}</td>
                        </tr>
                        {item.descricao ? (
                            <tr>
                                <td colSpan="3"><strong>Descrição:</strong> {item.descricao}</td>
                            </tr>
                        ) : null}
                        <tr>
                            <td colSpan="3">
                                <strong>Dimensões:</strong> {Number(item.comprimento).toLocaleString('pt-BR')} × {Number(item.largura).toLocaleString('pt-BR')} × {Number(item.altura).toLocaleString('pt-BR')} cm
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="3">
                                <strong>Volume:</strong> {Number(item.volumeUnitario).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} m³
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>Nº Reserva:</strong> {bagagem.reservaId}</td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>OS:</strong> {bagagem.id}</td>
                        </tr>
                    </tbody>
                </table>
                {this.exibirLimiteCupom()}
            </div>
        );
    }

    render() {
        const { bagagem, empresaSelecionada } = this.props;
        const temVolumes = bagagem && bagagem.itensMetroCubico && bagagem.itensMetroCubico.length > 0;

        return (
            <div>
                <div ref={this.props.referencias ? this.props.referencias.get('PASSAGEIRO').referencia : null}>
                    {this.exibirCupom('Passageiro', bagagem)}
                </div>

                <div ref={this.props.referencias ? this.props.referencias.get('EMPRESA').referencia : null}>
                    <div className="pagebreak"></div>
                    {this.exibirCupom('Empresa', empresaSelecionada)}
                </div>

                {temVolumes && (
                    <div ref={this.props.referencias ? this.props.referencias.get('VOLUMES')?.referencia : null}>
                        {bagagem.itensMetroCubico.map(item =>
                            this.exibirEtiquetaVolume(item, bagagem, empresaSelecionada?.nome)
                        )}
                    </div>
                )}
            </div>
        )
    }
}


